import Component from "~/components/ui/NotFound";
import type { HTMLWidget, ImageWidget } from "~/types/widgets";

export { default as LoadingFallback } from "~/components/LoadingFallback";

/**
 * Schema do admin (deco). Manter alinhado com Props em components/ui/NotFound.tsx.
 */
export interface Props {
  /**
   * @title Texto em cima do formulário
   */
  text: HTMLWidget;
  /**
   * @title Imagem de fundo
   */
  background: ImageWidget;
  /**
   * @title Link das recomendações
   * @description URL do banner "Enquanto isso, confira nossas recomendações para você" no modal de sucesso
   * @format uri
   */
  recommendationsHref?: string;
}

export const loader = (props: Props, _req: Request) => {
  return props;
};

export default function NotFound(props: Props) {
  return <Component {...props} />;
}
